import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
query cuartaCategoriaWithPagination($page: Int, $perPage: Int, $filters: FiltersCuartaCategoria) {
  cuartaCategoriaWithPagination(page: $page, first: $perPage, filters: $filters){
    paginatorInfo {
      currentPage
      count
      hasMorePages
      perPage
      total
    }
    data {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      register_date
      type
      discount_date
      amount
      observations
    }
  }
}
`

const GET_ALL = gql`
  query cuartaCategorias ($filters: FiltersCuartaCategoria) {
    cuartaCategorias (filters: $filters) {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      register_date
      type
      discount_date
      amount
      observations
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createCuartaCategoria ($input: CuartaCategoriaForm!) {
    createCuartaCategoria (input: $input) {
      id
      employee_id
      employee {
        id
        name
        last_name
        mothers_last_name
        fullName
        email
      }
      register_date
      type
      discount_date
      amount
      observations
    }
  }
`

const UPDATE = gql`
  mutation updateCuartaCategoria ($id: ID!, $input: CuartaCategoriaForm!) {
    updateCuartaCategoria (id: $id, input: $input) {
      id
      employee_id
      employee {
        id
        name
        last_name
        mothers_last_name
        fullName
        email
      }
      register_date
      type
      discount_date
      amount
      observations
    }
  }
`

const DELETE = gql`
  mutation deleteCuartaCategoria ($id: ID!) {
    deleteCuartaCategoria(id: $id) { 
      id
    }
  }
`

const VALIDATE_EXISTS_CUARTA_CATEGORIA = gql`
  mutation validateCuartaCategoria($id: ID, $input: CuartaCategoriaForm!) {
    validateCuartaCategoria (id: $id, input: $input) {
      success
      msgError
    }
  }
`

export {
  GET_WITH_PAGINATION,
  CREATE,
  UPDATE,
  DELETE,
  GET_ALL,
  VALIDATE_EXISTS_CUARTA_CATEGORIA
}
